/** @jsx jsx */
import { jsx } from 'theme-ui'
import Grid from '../helpers/grid'
import {
  AwardLabel,
  CupIcon,
  PeopleIcon,
  DatabaseIcon
} from '../winners/moreInfoConfig.jsx'
import NomineeCard from './NomineeCard.jsx'
import Heading from '../helpers/heading.jsx'
import Subheading from '../helpers/subheading.jsx'

export const PUBLIC_CHOICE = () => (
  <AwardLabel icon={PeopleIcon} title="Public choice" bgColor="#50F094" />
)

export const JUDGES_CHOICE = () => (
  <AwardLabel icon={CupIcon} title="Judges' choice" bgColor="#79C3FF" />
)

export const OPENSIGNAL_CHOICE = () => (
  <AwardLabel icon={DatabaseIcon} title="Opensignal data" bgColor="#FFA08B" />
)

const primaryNominees = [
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Network of the Year',
    nomineeNames: ['Tesco Mobile', 'giffgaff', 'iD Mobile']
  },
  {
    awardlabel: <JUDGES_CHOICE />,
    category: 'Handset of the Year',
    nomineeNames: [
      'Samsung Galaxy S23 Ultra',
      'Google Pixel 8 Pro',
      'OnePlus Open'
    ]
  }
]

const networkNominees = [
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Network for Customer Service',
    nomineeNames: ['Tesco Mobile', 'giffgaff', 'iD Mobile']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Network for Data',
    nomineeNames: ['Sky', 'giffgaff', 'iD Mobile']
  },
  {
    awardlabel: <JUDGES_CHOICE />,
    category: 'Best Network for Roaming',
    nomineeNames: ['iD Mobile', 'Lebara Mobile', 'o2']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Most Popular Mobile Network',
    nomineeNames: ['o2', 'Lebara Mobile', 'iD Mobile']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Network for Perks',
    nomineeNames: ['Sky', 'o2', 'Vodafone']
  }
]

const handsetAndSIMONominees = [
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Contract Network',
    nomineeNames: ['Tesco Mobile', 'iD Mobile', 'giffgaff']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Pay As You Go Network',
    nomineeNames: ['Sky', 'giffgaff', 'Vodafone']
  },
  {
    awardlabel: <JUDGES_CHOICE />,
    category: 'Best SIM Only Network',
    nomineeNames: ['SMARTY', 'giffgaff', 'Tesco Mobile']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Contract Value for Money',
    nomineeNames: ['iD Mobile', 'Tesco Mobile', 'giffgaff']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best SIM Only Value for Money',
    nomineeNames: ['SMARTY', 'giffgaff', 'iD Mobile']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best eSIM Provider',
    nomineeNames: ['Airalo', 'Holafly', 'Truphone']
  }
]

const MobilesSection = () => (
  <div>
    <Subheading>Top mobile awards</Subheading>
    <Grid gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)']}>
      {primaryNominees.map((nominee) => (
        <NomineeCard key={nominee.category} {...nominee} />
      ))}
    </Grid>

    <div>
      <Subheading>Networks</Subheading>
      <Grid gridTemplateColumns={['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}>
        {networkNominees.map((nominee) => (
          <NomineeCard key={nominee.category} {...nominee} />
        ))}
      </Grid>
    </div>

    <div>
      <Subheading>Handset contract and SIM Only</Subheading>
      <Grid gridTemplateColumns={['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}>
        {handsetAndSIMONominees.map((nominee) => (
          <NomineeCard key={nominee.category} {...nominee} />
        ))}
      </Grid>
    </div>
  </div>
)

export default MobilesSection
